import { render, staticRenderFns } from "./riskHazardPop.vue?vue&type=template&id=6180dae3"
import script from "./riskHazardPop.vue?vue&type=script&lang=js"
export * from "./riskHazardPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6180dae3')) {
      api.createRecord('6180dae3', component.options)
    } else {
      api.reload('6180dae3', component.options)
    }
    module.hot.accept("./riskHazardPop.vue?vue&type=template&id=6180dae3", function () {
      api.rerender('6180dae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/hazard/riskHazardPop.vue"
export default component.exports